<!--
  This icon is designed especially for Concertgebouw and not from an icon set,
  so be careful reusing it in other projects.
  -->

<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" role="graphics-symbol">
    <path fill="currentColor" d="M21.4 13.8 4.7 23.7c-1.5.9-3.2-.3-3.2-1.8V2.1C1.5.6 3.3-.5 4.7.3l16.7 9.9c1.5.6 1.5 2.7 0 3.6z" />
  </svg>
</template>
